<template lang="pug">
  router-link.flex.items-center.hover-text-blue(:class="{'text-blue': active && !disabled, 'pointer-events-none text-gray-300': disabled}", :to="rt", rel="noindex")
    .h-24.w-24.md-h-20.md-w-20.border.border-gray-300.relative.flex.items-center.justify-center.pb-4(:class="{'checked': active}")
    .ml-8.text-15.md-text-13.leading-none
      slot
</template>

<script>
export default {
  name: 'ProductFilter',
  props: ['active', 'rt', 'disabled']
}
</script>

<style scoped>
.h-24.checked::after{
  content: '';
  display:block;
  width:.7rem;
  height:1.3rem;
  border-right-width:1px;
  border-bottom-width:1px;
  border-color: currentColor;
  transform:rotate(45deg);
  transform-origin: center center;
}
</style>
